// ── PRODUCTION course map — real GPS points + geofence ────────────────
// The REAL Pine Bluff Country Club tee/green marks for all 18 holes, used by the
// production Course Scroll Map (TvCourseScrollMap) in the TV Monitor.
//
// This is SEPARATE from the /teststation/map2 sandbox: the sandbox keeps its
// office/backyard override on Hole 1 in ../teststation/map2Points.js and its own
// staged spots at /config/calibrationMap2/spots. THIS file uses the real Hole 1
// value and the production spots live at /config/productionMap/spots. Nothing
// here touches the sandbox.
//
// Par 3s (tee + green only, NO fairway zone/dot): 2, 5, 9, 13, 16.
// Real PBCC tee/green for all 18, each with a TEE fence of 20 yд (18.3 m) and a
// GREEN fence of 30 yд (27.4 m) — starting values; Mark tunes on-course. Par 3s
// (2, 5, 9, 13, 16) have tee + green only — no fairway. These are the live values.
export const PROD_POINTS = {
  1:  { par3:false, tee:{lat:34.182160,lng:-92.013430}, green:{lat:34.180250,lng:-92.017570}, teeRadiusM:22.86, greenRadiusM:27.4 },
  2:  { par3:true,  tee:{lat:34.179812,lng:-92.017462}, green:{lat:34.179731,lng:-92.019347}, teeRadiusM:22.86, greenRadiusM:27.4 },
  3:  { par3:false, tee:{lat:34.179727,lng:-92.019847}, green:{lat:34.176632,lng:-92.019733}, teeRadiusM:22.86, greenRadiusM:27.4 },
  4:  { par3:false, tee:{lat:34.176784,lng:-92.019204}, green:{lat:34.179471,lng:-92.017478}, teeRadiusM:22.86, greenRadiusM:27.4 },
  5:  { par3:true,  tee:{lat:34.179752,lng:-92.017216}, green:{lat:34.179681,lng:-92.015797}, teeRadiusM:22.86, greenRadiusM:27.4 },
  6:  { par3:false, tee:{lat:34.179014,lng:-92.015879}, green:{lat:34.176516,lng:-92.018617}, teeRadiusM:22.86, greenRadiusM:27.4 },
  7:  { par3:false, tee:{lat:34.176691,lng:-92.018941}, green:{lat:34.179217,lng:-92.016889}, teeRadiusM:22.86, greenRadiusM:27.4 },
  8:  { par3:false, tee:{lat:34.180053,lng:-92.017106}, green:{lat:34.180764,lng:-92.012418}, teeRadiusM:22.86, greenRadiusM:27.4 },
  9:  { par3:true,  tee:{lat:34.180773,lng:-92.011882}, green:{lat:34.181984,lng:-92.012362}, teeRadiusM:22.86, greenRadiusM:27.4 },
  10: { par3:false, tee:{lat:34.182391,lng:-92.013996}, green:{lat:34.181212,lng:-92.017311}, teeRadiusM:22.86, greenRadiusM:27.4 },
  11: { par3:false, tee:{lat:34.180410,lng:-92.018196}, green:{lat:34.180319,lng:-92.022784}, teeRadiusM:22.86, greenRadiusM:27.4 },
  12: { par3:false, tee:{lat:34.180890,lng:-92.022536}, green:{lat:34.181453,lng:-92.018818}, teeRadiusM:22.86, greenRadiusM:27.4 },
  13: { par3:true,  tee:{lat:34.180958,lng:-92.018567}, green:{lat:34.182173,lng:-92.017197}, teeRadiusM:22.86, greenRadiusM:27.4 },
  14: { par3:false, tee:{lat:34.182473,lng:-92.017466}, green:{lat:34.181420,lng:-92.022273}, teeRadiusM:22.86, greenRadiusM:27.4 },
  15: { par3:false, tee:{lat:34.181342,lng:-92.022779}, green:{lat:34.183275,lng:-92.021407}, teeRadiusM:22.86, greenRadiusM:27.4 },
  16: { par3:true,  tee:{lat:34.182817,lng:-92.020497}, green:{lat:34.182526,lng:-92.021954}, teeRadiusM:22.86, greenRadiusM:27.4 },
  17: { par3:false, tee:{lat:34.182013,lng:-92.022087}, green:{lat:34.182868,lng:-92.018615}, teeRadiusM:22.86, greenRadiusM:27.4 },
  18: { par3:false, tee:{lat:34.183024,lng:-92.018007}, green:{lat:34.182811,lng:-92.014058}, teeRadiusM:22.86, greenRadiusM:27.4 },
}

// Production geofence radius (meters): inside tee radius = Tee, inside green
// radius = Green, otherwise (on a non-par-3 hole) = Fairway.
export const RADIUS_M = 27

export const ZONES = ['tee', 'fairway', 'green']
const ORDER = { tee: 0, fairway: 1, green: 2 }

// Haversine distance in meters — exact enough at course scale.
export function distMeters(lat1, lng1, lat2, lng2) {
  const R = 6371000, toRad = (x) => (x * Math.PI) / 180
  const dLat = toRad(lat2 - lat1), dLng = toRad(lng2 - lng1)
  const a = Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2
  return 2 * R * Math.asin(Math.sqrt(a))
}

export function distToTee(holeNum, lat, lng) {
  const h = PROD_POINTS[holeNum]
  return h ? distMeters(lat, lng, h.tee.lat, h.tee.lng) : Infinity
}
export function distToGreen(holeNum, lat, lng) {
  const h = PROD_POINTS[holeNum]
  return h ? distMeters(lat, lng, h.green.lat, h.green.lng) : Infinity
}

// Which hole is the GPS on — the nearest hole by min(dist-to-tee, dist-to-green).
export function detectHole(lat, lng) {
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null
  let best = null, bestD = Infinity
  for (let h = 1; h <= 18; h++) {
    const d = Math.min(distToTee(h, lat, lng), distToGreen(h, lat, lng))
    if (d < bestD) { bestD = d; best = h }
  }
  return best
}

// Meters to the NEAREST hole's tee or green — used to reject off-course fixes
// (a phone at home ~30 km away must never paint a dot on the course map).
export function nearestHoleMeters(lat, lng) {
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return Infinity
  let best = Infinity
  for (let h = 1; h <= 18; h++) {
    const d = Math.min(distToTee(h, lat, lng), distToGreen(h, lat, lng))
    if (d < best) best = d
  }
  return best
}

// Raw geofence read at a position: inside tee radius -> tee, inside green radius
// -> green, else fairway. Par 3s have no fairway — 'between' returns null so the
// caller holds the previous zone (Tee) until the green.
export function geofenceZone(holeNum, lat, lng) {
  const h = PROD_POINTS[holeNum]
  if (!h || !Number.isFinite(lat) || !Number.isFinite(lng)) return null
  // Per-hole radius override (e.g. Hole 1's 25-yd home-test fences); default RADIUS_M.
  const teeR = Number.isFinite(h.teeRadiusM) ? h.teeRadiusM : RADIUS_M
  const greenR = Number.isFinite(h.greenRadiusM) ? h.greenRadiusM : RADIUS_M
  if (distMeters(lat, lng, h.tee.lat, h.tee.lng) <= teeR) return 'tee'
  if (distMeters(lat, lng, h.green.lat, h.green.lng) <= greenR) return 'green'
  return h.par3 ? null : 'fairway'
}

// The zones that have a staged dot for a given hole — par 3s skip fairway.
export function zonesForHole(holeNum) {
  return PROD_POINTS[holeNum]?.par3 ? ['tee', 'green'] : ZONES
}

// Forward-only advance. `prev` is { hole, zoneIdx } or undefined. Zone only moves
// tee -> fairway -> green within a hole; a new hole resets to the read.
export function advanceZone(prev, holeNum, lat, lng) {
  const cand = geofenceZone(holeNum, lat, lng)
  if (!prev || prev.hole !== holeNum) {
    return { hole: holeNum, zoneIdx: cand ? ORDER[cand] : 0 }
  }
  const candIdx = cand != null ? ORDER[cand] : prev.zoneIdx
  return { hole: holeNum, zoneIdx: Math.max(prev.zoneIdx, candIdx) }
}

export function zoneName(state) {
  return ZONES[state?.zoneIdx ?? 0]
}
